module.exports = __webpack_public_path__ + "static/media/spo.cb19b6ba.JPG";